import { render, staticRenderFns } from "./Inmain.vue?vue&type=template&id=446e8dc3&scoped=true&"
import script from "./Inmain.vue?vue&type=script&lang=js&"
export * from "./Inmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e8dc3",
  null
  
)

export default component.exports